// extracted by mini-css-extract-plugin
export default {"headline":"app_headline__e7pFp","loader":"app_loader__gseNA"};